import { render, staticRenderFns } from "./ReadCounselingQuestions.vue?vue&type=template&id=984b3cec&scoped=true&"
import script from "./ReadCounselingQuestions.vue?vue&type=script&lang=ts&"
export * from "./ReadCounselingQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984b3cec",
  null
  
)

export default component.exports